<ng-container *ngFor="let option of possibleValues; let i = index">
  <div
    class="option-container"
    [class.margin-bottom]="!isLastItem(possibleValues, i)"
    [class.selected]="isSelected(option)"
    (click)="handleInput(option)"
  >
    <div class="option-checkbox" [class.selected]="isSelected(option)">
      <app-lucide-icon *ngIf="isSelected(option)" [iconName]="'check'"></app-lucide-icon>
    </div>

    <span class="option-text">{{ option }}</span>
  </div>
</ng-container>
